<div class="economics-wrapper">
  <div class="loading" *ngIf="!costs"></div>
  <ng-container *ngIf="costs">
    <p [innerHTML]="'moderat.sanierung.finanzierung.wirtschaftlichkeit.teaser' | translate"></p>
    <h4 [innerHTML]="'moderat.sanierung.finanzierung.wirtschaftlichkeit.diagramm.headline' | translate: {amount: costs.overall.sum | number: '1.0-0'} "></h4>

    <div class="chart-wrapper">
      <div class="bar-wrapper" [style.height]="(barFactor * 100) + '%'">
        <div class="bar">{{costs.overall.modernization | number: '1.0-0'}} €</div>
        <span>{{'moderat.sanierung.finanzierung.wirtschaftlichkeit.diagramm.modernisierung' | translate}}</span>
      </div>
      <div class="bar-wrapper primary" [style.height]="((1 - barFactor) * 100) + '%'">
        <div class="bar">{{costs.overall.repair | number: '1.0-0'}} €</div>
        <span>{{'moderat.sanierung.finanzierung.wirtschaftlichkeit.diagramm.instandhaltung' | translate}}</span>
      </div>
    </div>


    <p [innerHTML]="'moderat.sanierung.finanzierung.wirtschaftlichkeit.tabelle.teaser' | translate: {amount: costs.overall.sum - costs.funding_grants.sum - anfrage.eigenkapital - costs.promotional_loan.sum | number: '1.0-0'}"></p>
    <table>
      <thead>
        <tr>
          <th [innerHTML]="'moderat.sanierung.finanzierung.wirtschaftlichkeit.tabelle.zeitraum' | translate"></th>
          <th [innerHTML]="'moderat.sanierung.finanzierung.wirtschaftlichkeit.tabelle.20jahre' | translate"></th>
          <th [innerHTML]="'moderat.sanierung.finanzierung.wirtschaftlichkeit.tabelle.21jahre' | translate"></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th>
            <span [innerHTML]="'moderat.sanierung.finanzierung.wirtschaftlichkeit.tabelle.kredit' | translate"></span>
            <button type="button" class="help-button" [attr.aria-expanded]="toggles.help1" [attr.aria-controls]="'finanzierung-help1'" [attr.aria-label]="'arialabel.toggle.help' | translate" (click)="toggles.help1 = !toggles.help1"><i class="icon-help-circle"></i></button>
          </th>
          <td>{{formatAmount((costs.monthly_balance.credit * -1) - equityCredit)}}</td>
          <td>{{formatAmount(costs.monthly_balance_after20.credit)}}</td>
        </tr>
        <tr *ngIf="toggles.help1">
          <td colspan="3">
            <div class="callout">
              <button type="button" class="close-button" [attr.aria-label]="'arialabel.close' | translate" (click)="toggles.help1 = false"><i class="icon-x"></i></button>
              <p id="finanzierung-help1" [innerHTML]="'moderat.sanierung.finanzierung.wirtschaftlichkeit.tabelle.kredit.hilfe' | translate"></p>
            </div>
          </td>
        </tr>
        <tr>
          <th>
            <span [innerHTML]="'moderat.sanierung.finanzierung.wirtschaftlichkeit.tabelle.einsparung' | translate"></span>
            <button type="button" class="help-button" [attr.aria-expanded]="toggles.help2" [attr.aria-controls]="'finanzierung-help2'" [attr.aria-label]="'arialabel.toggle.help' | translate" (click)="toggles.help2 = !toggles.help2"><i class="icon-help-circle"></i></button>
          </th>
          <td>{{formatAmount(costs.monthly_balance.saving)}}</td>
          <td>{{formatAmount(costs.monthly_balance_after20.saving)}}</td>
        </tr>
        <tr *ngIf="toggles.help2">
          <td colspan="3">
            <div class="callout">
              <button type="button" class="close" [attr.aria-label]="'arialabel.close' | translate" (click)="toggles.help2 = false"><i class="icon-x"></i></button>
              <p id="finanzierung-help2" [innerHTML]="('moderat.sanierung.finanzierung.wirtschaftlichkeit.tabelle.einsparung.hilfe' + (costs.monthly_balance.saving < 0? '.negativ' : '')) | translate: {percent: (costs.price_increase) | number: '1.0-1'}"></p>
            </div>
          </td>
        </tr>
        <tr>
          <th [innerHTML]="'moderat.sanierung.finanzierung.wirtschaftlichkeit.tabelle.summe' | translate"></th>
          <td>{{formatAmount(costs.monthly_balance.sum)}}</td>
          <td>{{formatAmount(costs.monthly_balance_after20.sum)}}</td>
        </tr>
      </tbody>
    </table>

    <div class="callout primary-light" *ngIf="costs.monthly_balance.sum < 0" [innerHTML]="'moderat.sanierung.finanzierung.wirtschaftlichkeit.fazit.negativ' | translate: {amount: (costs.monthly_balance.sum * -1 | number: '1.0-0')}"></div>
    <div class="callout primary-light" *ngIf="costs.monthly_balance.sum >= 0" [innerHTML]="'moderat.sanierung.finanzierung.wirtschaftlichkeit.fazit.positiv' | translate: {amount: (costs.monthly_balance.sum | number: '1.0-0')}"></div>
  </ng-container>
</div>
